import { EntityType } from '@neptune/shared/entity-domain';

export const ENTITY_TYPE_TO_TEXT_MAP: Record<EntityType, string> = {
  run: 'run',
  project: 'project',
};
